import Todo from '../models/Todo';
import {localAxiosRequest} from "@/utils/axios";
import {localAxiosRequest2} from "@/utils/axios";
const CARTS_BASE_URL = '/carts';

/**
 * 加入购物车
 */
const addCart = function (param: object): Promise<Todo[]> {
    return localAxiosRequest2({
        method: 'POST',
        url: `${CARTS_BASE_URL}/add`,
        data: param
    }, true);
};

/**
 * 判断此书是否可加入购物车
 */
const cartCheck = function (bookNo: string,vendorId:number): Promise<Todo[]> {
    return localAxiosRequest({
        method: 'GET',
        url: `${CARTS_BASE_URL}/cart_check?bookNo=${encodeURIComponent(bookNo)}&vendorId=${vendorId}`,
    });
};

/**
 * 删除购物车所选数据
 */
const delCart = function (param: object): Promise<Todo[]> {
    return localAxiosRequest({
        method: 'DELETE',
        url: `${CARTS_BASE_URL}/delete`,
        data: param
    });
};

/**
 * 立即购买--添加到待确认
 */
const confirm = function (param: object): Promise<Todo[]> {
    return localAxiosRequest({
        method: 'POST',
        url: `${CARTS_BASE_URL}/confirm`,
        data: param
    },true);
};

/**
 * 待确认列表删除所选
 */
const delCartBook= function (bookNos: string): Promise<Todo[]> {
    return localAxiosRequest({
        method: 'GET',
        url: `${CARTS_BASE_URL}/cart_book/delete?bookNos=${encodeURIComponent(bookNos)}`,
    });
};

/**
 * 获取订单详情（已下单）
 */
const getBookdetails = function (bookId: string): Promise<Todo[]> {
    return localAxiosRequest({
        method: 'GET',
        url: `${CARTS_BASE_URL}/book/${encodeURIComponent(bookId)}`,
    });
};

/**
 * 获取详情页链接地址
 */
const checkDuplicate = function (isbn: string, title: string): Promise<Todo[]> {
    return localAxiosRequest({
        method: 'GET',
        url: `${CARTS_BASE_URL}/check_duplicate?isbn=${encodeURIComponent(isbn)}&title=${encodeURIComponent(title)}`,
    });
};

export { addCart, cartCheck, delCart, confirm, delCartBook, getBookdetails, checkDuplicate };
